import { render, staticRenderFns } from "./RightIndex.vue?vue&type=template&id=6e5b95eb&"
import script from "./RightIndex.vue?vue&type=script&lang=js&"
export * from "./RightIndex.vue?vue&type=script&lang=js&"
import style0 from "./RightIndex.vue?vue&type=style&index=0&id=6e5b95eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports